import { render } from "./EditCustomer.vue?vue&type=template&id=a0b6fdd4&scoped=true"
import script from "./EditCustomer.vue?vue&type=script&lang=js"
export * from "./EditCustomer.vue?vue&type=script&lang=js"

import "./EditCustomer.vue?vue&type=style&index=0&id=a0b6fdd4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/front/intranet-gpaie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0b6fdd4"]])

export default __exports__